import React, { useRef } from 'react';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { useCosDownload } from '@/pages/aigc/pages/Agent/ChatPage/hooks/useCosDownload';
import { useAgentModelsData } from '../AgentCollection/hooks';
import { useSkillsData } from '../SkillsCollection/hooks';
import FileLibraryTable from './components/FileLibraryTable';
import FileLibraryToolbar from './components/FileLibraryToolbar';
import { useFileLibraryList } from './hooks/useFileLibraryList';
import { useFileLibraryQuery } from './hooks/useFileLibraryQuery';
import { useFileLibraryScrollLoad } from './hooks/useFileLibraryScrollLoad';
import { useOpenOriginalChat } from './hooks/useOpenOriginalChat';
import './index.scss';

/** Brainy 文件库页面 */
const FileLibraryPage: React.FC = () => {
  const { formatMessage, locale } = useIntl();
  const bodyRef = useRef<HTMLDivElement>(null);

  const {
    pageTabs,
    activeId,
    onTabChange,
    listQuery,
    patchQuery,
    searchDraft,
    handleSearchChange,
    sortInfo,
    handleSortChange,
    activeFilterCount,
  } = useFileLibraryQuery();

  const { authorizedAgents, loading: agentsLoading } = useAgentModelsData();
  const isEN = locale === LANGUAGE_EN;
  const { allSkills } = useSkillsData(isEN);
  const { openOriginalChat } = useOpenOriginalChat();
  const { downloadCosFile } = useCosDownload();

  const { files, loading, loadingMore, loadMore, noMore } = useFileLibraryList(
    listQuery,
    bodyRef,
  );

  useFileLibraryScrollLoad(bodyRef, loadMore, {
    loading,
    loadingMore,
    noMore,
    filesLength: files.length,
  });

  return (
    <div className="dba-file-library">
      <h1 className="dba-file-library__title">
        {formatMessage({ id: 'dba_file_library_title' })}
      </h1>
      <FileLibraryToolbar
        pageTabs={pageTabs}
        activeId={activeId || 'all'}
        onTabChange={onTabChange}
        listQuery={listQuery}
        patchQuery={patchQuery}
        searchDraft={searchDraft}
        onSearchChange={handleSearchChange}
        activeFilterCount={activeFilterCount}
        agents={authorizedAgents}
        agentsLoading={agentsLoading}
      />
      <div className="dba-file-library__body" ref={bodyRef}>
        <FileLibraryTable
          files={files}
          loading={loading}
          loadingMore={loadingMore}
          sortInfo={sortInfo}
          authorizedAgents={authorizedAgents}
          allSkills={allSkills}
          onSortChange={handleSortChange}
          onOpenChat={openOriginalChat}
          onDownload={file => {
            void downloadCosFile(file.file_cos_url, file.file_name);
          }}
        />
      </div>
    </div>
  );
};

export default FileLibraryPage;
